export default function AuditsDirective() {
  return {
    template: require('./audits.html'),
    scope: {
      activeAudits: '=',
      activeAuditsHaveDeletedAgency: '=',
      completedAudits: '=',
    },
    controller: () => { /* 'AuditsController' */ },
    controllerAs: 'auditsVM',
    bindToController: true,
    replace: true
  };
}
